import React, { FunctionComponent, useEffect } from "react"
import { RunStatusDto, useGetRunProgressQuery } from "@store/services/runService"
import { Navigate, useNavigate, useParams } from "react-router"
import { Box, CircularProgress } from "@mui/material"

const pollingInterval = 5000

export const RunProgress: FunctionComponent = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  let timeoutId: NodeJS.Timeout | number = -1
  if (!id) {
    navigate(-1)
    return <></>
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- FIX: hooks that can't be called conditionally
  const { data, refetch, status } = useGetRunProgressQuery(id)

  // eslint-disable-next-line react-hooks/rules-of-hooks -- FIX: hooks that can't be called conditionally
  useEffect(() => {
    return () => clearTimeout(timeoutId)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  }, [])

  let errorMessage = ""
  // go to key
  if (data?.status === RunStatusDto.DONE) {
    return <Navigate to={`/Results/Result/${data.key}`} />
  } else if (data?.status === RunStatusDto.ERROR) {
    errorMessage = data?.extra?.message || "Unknown Error"
  } else if (status === "fulfilled") {
    timeoutId = setTimeout(() => {
      refetch()
    }, pollingInterval)
  }
  let message: string | React.ReactElement = ""
  if (data?.status) {
    const arr = data.status.split("-")
    message = data ? (
      <span>
        Now {arr[0]}: "{arr[1]}" task
      </span>
    ) : (
      ""
    )
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "1000px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <CircularProgress
          size="5em"
          color="error"
          variant="indeterminate"
          thickness={6}
          sx={{
            marginBottom: 0,
          }}
        />
        <h1>{message}</h1>
        <h2 style={{ color: "#d6002a" }}>{errorMessage}</h2>
      </Box>
    </Box>
  )
}
